<template>
  <div class="chatbox" v-if="visible">
    <div class="chatbox_title">
      <div>语音与动作合成</div>
      <div @click="close" class="chatbox_close">
        <i class="iconfont icon-guanbi"></i>
      </div>
    </div>

    <div>
      <ttsbox :user="moxing" :t9render="t9render" @backfun="backfun"></ttsbox>
    </div>
  </div>
</template>

<script>

import ttsbox from '@/components/t9tts/composebox.vue'

export default {
  name: "compose",
  props: {
    moxing: {
      type: Object,
      default: function () {
        return {}
      }
    },
    t93d: {
      type: Object,
      default: function () {
        return {}
      }
    },
    modelClass: {
      type: Object,
      default: function () {
        return {}
      }
    },
    t9render: {
      type: Object,
      default: function () {
        return {}
      }
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  components: {
    ttsbox
  },
  created () {
    // console.log('compose接收的user对象:moxing', this.moxing)
  },
  data () {
    return {
      chatboxshow: true
    }
  },
  methods: {
    close () {
      // this.visible = false;
      this.$emit('update:visible', false)
    },
    backfun (obj) {
      this.$emit('backfun', obj)
      this.$emit('update:visible', false)
    }
  }
}
</script>

<style lang="scss" scoped>
.chatbox {
  position: fixed;
  width: 400px;
  max-height: 800px;
  background-color: #fff;
  border-radius: 10px;
  bottom: 10px;
  left: 50%;
  margin-left: -200px;
  z-index: 999;
  padding: 10px;
  box-shadow: 1px 2px 10px rgba(0, 0, 0, 0.3);
}
.chatbox_title {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  font-size: 16px;
  .chatbox_close {
    cursor: pointer;

    &:hover i {
      color: #39f;
    }
  }
}
</style>